import { FormControl, Grid, MenuItem, Select } from '@material-ui/core';
import { Product } from '@nemuru-eng/js-api-client';

import { usePageContext } from '../../contexts/PageContext/PageContext';
import { Text } from '../shared/components/Text';

export function LoanSourceWidget() {
  const {
    state: { loanSourceType },
    actions: { setLoanSourceType },
  } = usePageContext();

  const loanSourceTypes = [Product.CONSUMER_LOAN, Product.AUTO, Product.CREDIT_LINE];
  const onSelectType = (type) => {
    setLoanSourceType(type);
    // dispatch({
    //   type: pageSetLoanSourceType.types.default,
    //   payload: type,
    // });
  };
  return (
    <Grid>
      <FormControl className="mt-0">
        <Select
          // MenuProps={{
          //     disableScrollLock: true,
          // }}
          disableUnderline
          value={loanSourceType || loanSourceTypes[0]}
          onChange={(e) => onSelectType(e.target.value)}
        >
          {loanSourceTypes.map((type) => (
            <MenuItem key={type} value={type}>
              <Text tId={type} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  );
}
